import './IconButton.css'
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'
import cx from 'classnames'
import { buttonVariantClasses, ButtonVariant, ButtonSize } from '../Button/Button'

type IconButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  icon: React.ReactNode
  sizeType?: ButtonSize
  disabled?: boolean
  variant?: ButtonVariant
}

const iconButtonSizeClasses = {
  xs: 'icon-btn-xs',
  sm: 'icon-btn-sm',
  md: 'icon-btn-md'
}

export function IconButton({
  icon,
  className,
  sizeType = 'sm',
  variant = 'default',
  onClick,
  disabled,
  ...iconButtonProps
}: IconButtonProps) {
  return (
    <button
      className={cx(
        'icon-btn-base',
        buttonVariantClasses[variant],
        iconButtonSizeClasses[sizeType],
        className
      )}
      onClick={onClick}
      {...iconButtonProps}
      disabled={disabled}
    >
      <span className="size-6">{icon}</span>
    </button>
  )
}
